import { Capacitor } from '@capacitor/core';

export async function initCapacitor() {
  if (!Capacitor.isNativePlatform()) return;

  const { StatusBar, Style } = await import('@capacitor/status-bar');
  const { SplashScreen } = await import('@capacitor/splash-screen');

  StatusBar.setStyle({ style: Style.Light });
  StatusBar.setBackgroundColor({ color: '#3361FF' });
  SplashScreen.hide();
}
